import Base from './../Base.vue'
import Live from '../layout/authenticated/lives.vue'
import Login from '../layout/auth/login.vue'
import BaseAuth from '../layout/authenticated/Base.vue'
import { dataShared } from '../store'
import { markRaw } from 'vue'
import Events from '../layout/authenticated/events.vue'
import Noticias from '../layout/authenticated/noticias.vue'
import Plans from '../layout/authenticated/plans.vue'
import Profile from '../layout/authenticated/profile.vue'
import Purchase from '../layout/authenticated/purchase.vue'
import router from '@/router'
import Lutas from '../layout/authenticated/lutas.vue'

export const sharedRoutes = [
  // site
  {
    path: '',
    name: 'inicio',
    component: Base,
    meta: {
      public: false,
      appC: true
    }
  },

  // login
  {
    path: '/auth',
    name: 'auth',
    component: Login,
    meta: {
      public: true,
      appC: true,
      checkAuth: true,
    }
  },

  // auth client app
  {
    component: BaseAuth,
    children: [
      {
        path: '/events', // eventos
        name: 'events',
        beforeEnter: (to, from, next) => {
          dataShared.dispatch('setComponentActive', markRaw(Events))
          next()
        },
        meta: {
          public: false,
          appC: true
        }
      },
      {
        path: '/notices', // blog
        name: 'notices',
        beforeEnter: (to, from, next) => {
          dataShared.dispatch('setComponentActive', markRaw(Noticias))
          next()
        },
        meta: {
          public: false,
          appC: true
        }
      },
      {
        path: '/lutas', // lives
        name: 'fights',
        beforeEnter: (to, from, next) => {
          dataShared.dispatch('setComponentActive', markRaw(Live))
          next()
        },
        meta: {
          public: false,
          appC: true
        }
      },
      {
        path: '/live/:eventId?', // lives
        name: 'live',
        beforeEnter: (to, from, next) => {
          dataShared.dispatch('setComponentActive', markRaw(Lutas))
          next()
        },
        meta: {
          public: false,
          appC: true
        }
      },
      {
        path: '/purchase/:id/event', // lives
        name: 'purchase',
        beforeEnter: (to, from, next) => {
          dataShared.dispatch('setComponentActive', markRaw(Purchase))
          next()
        },
        meta: {
          public: false,
          appC: true
        }
      },
      {
        path: '/plans', // ppv
        name: 'plans',
        beforeEnter: (to, from, next) => {
          dataShared.dispatch('setComponentActive', markRaw(Plans))
          next()
        },
        meta: {
          public: false,
          appC: true
        }
      },
      {
        path: '/profile',
        name: 'profile',
        beforeEnter: (to, from, next) => {
          dataShared.dispatch('setComponentActive', markRaw(Profile))
          next()
        },
        meta: {
          public: false,
          appC: true
        }
      }
    ]
  }
]
